<template>
    <!-- <div :style="{ backgroundImage: 'url(' + tempDetail.certificate_image_details.file.file_path + ')' }">
        hi
        <pre>{{tempDetail}}</pre>{{tempDetail}}
    </div> -->
      <div v-if="tempDetail" icon="feather icon-settings">
            <div
          v-if="tempDetail.certificate_image_details==null"
            v-html="tempDetail.content"
            class="text-center previewed_action_holder"
            
          ></div>
          <div
           v-else
            v-html="tempDetail.content"
            class="text-center previewed_action_holder"
            :style="{ backgroundImage: 'url(' + tempDetail.certificate_image_details.file.file_path + ')' }"
          ></div>
        </div>
          <div title="Actions" v-else icon="feather icon-settings">
          <div
          v-if="tempCertDetails && tempCertDetails.certificate_image_details==null"
            v-html="tempCertDetails.content"
            class="text-center previewed_action_holder"
            
          ></div>
            <div
            v-else
            v-html="tempCertDetails.content"
            class="text-center previewed_action_holder"
            :style="{ backgroundImage: 'url(' + tempCertDetails.certificate_image_details.file.file_path + ')' }"
          ></div>
        </div>
</template>
<script>
export default {
  props:{
    tempDetail:{},
    tempCertDetails:{}
  }
}
</script>